export default __webpack_public_path__ + "static/media/table_NPC_Hk.c6ea01a6.webp";